//import Swal from 'sweetalert2/src/sweetalert2'

export const initHeader = () => {
    let header = document.getElementById('header');

    const checkScroll = () => {
        let shouldAddClass = window.scrollY > 50;
        header.classList.toggle('scrolled', shouldAddClass);
    };

    window.addEventListener('scroll', checkScroll);

    checkScroll();

};
